import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { Table, Modal, Button, ModalBody, ModalFooter, ModalHeader, Spinner, Alert, Form as BootstrapForm, InputGroup } from 'react-bootstrap';
import { SuccessToolbar } from '../../lib/formControls';
import { apiUrl, apiKey, cryptoService } from '../../lib/config';
import { useAuth, useApiPatch } from '../../hooks';

const validationSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required('New password is required')
      .min(8, 'Password must be at least 8 characters')
      /*.matches(/[A-Z]/, 'Must contain at least one uppercase letter')*/
      .matches(/[a-z]/, 'Must contain at least one lowercase letter')
      .matches(/[0-9]/, 'Must contain at least one number')
      .matches(/[!@#$%^&*]/, 'Must contain at least one special character'),
    confirmPassword: Yup.string()
      .required('Please confirm your new password')
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
  });

const PasswordWatcher = ({ customError, setCustomError }) => {
  const { values } = useFormikContext();

  useEffect(() => {
      if (customError && (values.newPassword || values.confirmPassword)) {
        setCustomError('');
      }
    }, [
      values.newPassword,
      values.confirmPassword
    ]);

    return null;
  };

export const ChangePasswordModal = ({ show, onHide }) => {
  const [showPasswords, setShowPasswords] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [customerror, setCustomerror] = useState('');
  const { userInfo, authToken, logout } = useAuth();
  const { patchData, loading, error, responseData } = useApiPatch('users',authToken);

  const handleSubmit = async (values, { resetForm }) => {
    let newPasswordVal = values?.newPassword;
    setCustomerror('');
    setSubmitted(false);
    if(newPasswordVal) {

      /*let newPassword = cryptoService.encryptData(newPasswordVal);*/
      let newPassword = newPasswordVal;
      const payloadObj = {
          id: userInfo.userId,
          password: newPassword,
      };
      let payload = JSON.stringify(payloadObj);

      const { result, error: apiError } = await patchData(payload);
      if(result && result?.data) {
          setSubmitted(true);
          setTimeout(()=>{
            onHide();
            logout();
          },700);
      } else {
        setCustomerror(apiError);
      }
    } else {
        setCustomerror('Current Password & New Password should not be empty.');
    }
    //resetForm();
  };

  return (
    <Modal role="dialog" className='change-password-popup' size='md' show={show} centered>
      <div className="modal-content">
        <button type="button" onClick={onHide} className="btn-close position-absolute end-0 top-0 m-3"></button>
        <ModalHeader>Change Password</ModalHeader>
        <ModalBody>
          
          <div className="d-flex justify-content-center">
            <div className="p-1" style={{ width: '100%' }}>

              {customerror && <Alert variant="danger mb-3" dismissible >{customerror}</Alert>}

              {submitted && <SuccessToolbar message="🎉 Password have been changed successfully." />}

              <Formik
                initialValues={{
                  newPassword: '',
                  confirmPassword: ''
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <PasswordWatcher customError={customerror} setCustomError={setCustomerror} />

                    {/* New Password */}
                    <BootstrapForm.Group className="mb-3" controlId="newPassword">
                      <BootstrapForm.Label>New Password</BootstrapForm.Label>
                      <Field
                        name="newPassword"
                        type={showPasswords ? 'text' : 'password'}
                        as={BootstrapForm.Control}
                        placeholder="Enter new password"
                      />
                      <ErrorMessage name="newPassword" component="div" className="text-danger small" />
                    </BootstrapForm.Group>

                    {/* Confirm Password */}
                    <BootstrapForm.Group className="mb-3" controlId="confirmPassword">
                      <BootstrapForm.Label>Confirm New Password</BootstrapForm.Label>
                      <Field
                        name="confirmPassword"
                        type={showPasswords ? 'text' : 'password'}
                        as={BootstrapForm.Control}
                        placeholder="Confirm new password"
                      />
                      <ErrorMessage name="confirmPassword" component="div" className="text-danger small" />
                    </BootstrapForm.Group>

                    <div className="d-grid mt-4">
                      <Button variant="primary" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? (<>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        {' '}Changing...
                                        </>
                                        ) : ('Change Password')}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>  
          </div>

        </ModalBody>
        {/* <ModalFooter>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
        </ModalFooter> */}
      </div>
    </Modal>
  );
};

